import React from 'react';

import UpdateIcon from '@material-ui/icons/Update';
import { noop } from 'lodash';
import { func, string, arrayOf } from 'prop-types';
import { formatDistance } from 'date-fns';

import StateLozenge from 'shared-components/StateLozenge';
import styles from '../styles/applicationDetailsContainer.scss';

const AppPackageHeader = ({
  id,
  name,
  description,
  status,
  signedIconUrl,
  iconUrl,
  modifiedDateTime,
  actions,
  onClickAction
}) => {
  return (
    <div className={styles['header-container']}>
      <div>
        <img src={iconUrl} className={styles['icon']} />
      </div>
      <div>
        <h1 className={styles['applicationName']}>
          {name}
          <span className={styles['applicationState']}>
            <StateLozenge
              type="application"
              state={status}
              actions={actions}
              onClickAction={onClickAction}
            />
          </span>
          <span className={styles['appModified']}>
            <UpdateIcon />
            <span style={{ textTransform: 'uppercase' }}>
              Last Updated:&nbsp;&nbsp;
            </span>
            <i>
              {formatDistance(new Date(modifiedDateTime), new Date(), {
                includeSeconds: true
              })}{' '}
              ago
            </i>
          </span>
        </h1>
        <p className={styles['appId']}>
          ID: {id}
        </p>
        <p className={styles['description']}>
          {description}
        </p>
      </div>
    </div>
  );
};

AppPackageHeader.propTypes = {
  id: string.isRequired,
  name: string.isRequired,
  description: string.isRequired,
  status: string.isRequired,
  iconUrl: string,
  signedIconUrl: string,
  modifiedDateTime: string.isRequired,
  actions: arrayOf(string),
  onClickAction: func
};

AppPackageHeader.defaultProps = {
  onClickAction: noop,
  actions: []
};

export default AppPackageHeader;



// WEBPACK FOOTER //
// ./src/client/plugins/applications/components/AppPackageHeader.js